import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Dealer from '../../entities/admin/dealer'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface DealerState extends ListState<Dealer>{
    editModel: Dealer;
    mapList: Array<Dealer>,
    allList: Array<Dealer>,
    activeList: Array<Dealer>,
    red: number,
}
class DealerModule extends ListModule<DealerState,any,Dealer>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Dealer>(),
        loading:false,
        editModel: new Dealer(),
        allList: new Array<Dealer>(),
        activeList: new Array<Dealer>(),
        mapList: new Array<Dealer>(),
        red: 0,
        path: 'dealers'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
        async getAllActive(context: ActionContext<DealerState, any>, payload: any) {
            if (context.state.activeList != undefined && context.state.activeList.length > 0) return context.state.activeList;
            let params = (payload.data == undefined ? {} : payload.data);
            params.perPage = -1;
            context.state.loading = true;
            let reponse = await Ajax.get('/api/dealers', { params: params }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.allList = reponse.data.result;
            context.state.activeList = reponse.data.result;
            context.state.loading = false;
        },
        async getMapList(context: ActionContext<DealerState, any>, payload: any) {
            if (context.state.mapList != undefined && context.state.mapList.length > 0) return true;
            let params = (payload.data == undefined ? {} : payload.data);
            params.perPage = -1;
            context.state.loading = true;
            let reponse = await Ajax.get('/api/dealers', { params: params }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.mapList = reponse.data.result;                
            context.state.loading = false;
        },
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        edit(state: DealerState, model: Dealer) {
            state.editModel = model;
            state.editModel.ubigeo = {
                department: model.department_id,
                province: model.province_id,
                district: model.district_id
            };
        },
        setRed(state: DealerState, red: number) {
            state.red = red;
            let list = state.allList;
            if (state.red > 0) {
                list = state.allList.filter(d => {
                    return d.type_id == state.red;
                });
            }
            state.activeList = list;
            state.mapList = list;
        },
    });
}
const dealerModule=new DealerModule();
export default dealerModule;
